
/** 
 * @callback  Subscriber
 * @param {string} key
 * @param {function} cb
 * @returns {Function} - Unsubcribe Function
 */

/** 
 * @callback Emitter
 * @param {string} key
 * @param {any} value
 */

/**
 * 
 * @returns {[Subscriber,Emitter ]}
 */
const observable = () => {
    const eventPool = new Map();

    const subscriber = (key, cb) => {
        let callbacks = new Set();
        if (eventPool.has(key)) {
            callbacks = eventPool.get(key);
        }
        callbacks.add(cb);
        eventPool.set(key, callbacks);
        return () => {
            if (eventPool.has(key)) {
                const callbacks = eventPool.get(key);
                callbacks.delete(cb);
                eventPool.set(key, callbacks);
            }
        }
    }

    const emitter = (key, value) => {
        if (eventPool.has(key)) {
            const callbacks = eventPool.get(key);
            callbacks.forEach(cb => {
                cb.call(null, value);
            })
        }

    }
    return [subscriber, emitter];
};

export {
    observable
}